import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, ArrowUpRight } from 'lucide-react';

const links = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/solutions', label: 'Solutions' },
  { to: '/case-studies', label: 'Case Studies' },
  { to: '/industries', label: 'Industries' },
  { to: '/insights', label: 'Insights' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

export function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="top-nav"
      className="sticky top-0 z-40 w-full backdrop-blur-md bg-white/80 border-b border-[#051A24]/5"
    >
      <div className="max-w-[1200px] mx-auto px-6 py-3 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
          onClick={() => setOpen(false)}
        >
          <img
            src="/yp-nova-logo.jpg"
            alt="YP Nova"
            className="h-20 md:h-24 w-auto object-contain transition-transform group-hover:-rotate-3 group-hover:scale-105"
          />
          <span className="sr-only">YP Nova</span>
        </Link>

        {/* Desktop links */}
        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-full text-sm transition-all ${
                  isActive
                    ? 'bg-gradient-to-r from-[#051A24] to-[#6D28D9] text-white shadow-[0_4px_16px_rgba(109,40,217,0.35)]'
                    : 'text-[#051A24] hover:bg-[#7C3AED]/10 hover:text-[#4C1D95]'
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center">
          <Link
            to="/contact"
            data-testid="nav-cta-start-project"
            className="inline-flex items-center gap-1 bg-gradient-to-r from-[#051A24] to-[#6D28D9] text-white rounded-full px-5 py-2 text-sm hover:shadow-[0_8px_28px_rgba(109,40,217,0.45)] transition-shadow"
          >
            Book a Discovery Call <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 rounded-full flex items-center justify-center text-[#051A24] hover:bg-[#051A24]/5"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-[#051A24]/5 bg-white"
        >
          <nav className="max-w-[1200px] mx-auto px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/'}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-2xl text-base ${
                    isActive
                      ? 'bg-gradient-to-r from-[#051A24] to-[#6D28D9] text-white'
                      : 'text-[#051A24] hover:bg-[#7C3AED]/10'
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta"
              className="mt-2 inline-flex items-center justify-center gap-1 bg-gradient-to-r from-[#051A24] to-[#6D28D9] text-white rounded-full px-5 py-3 text-sm"
            >
              Book a Discovery Call <ArrowUpRight className="w-4 h-4" />
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
